import script from "./Pla08DeferimentoEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./Pla08DeferimentoEditPage.vue?vue&type=script&setup=true&lang=js"

import "./Pla08DeferimentoEditPage.vue?vue&type=style&index=0&id=06dafa02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06dafa02"]])

export default __exports__